
/**
 * 双位数字 小于10补0
 */
export const twodigit = val => {
  return `0${val}`.slice(-2)
}

/**
   * 日期格式化
   */
export const dateFormat = (date, format) => {
  let formatStr = format || 'yyyy-MM-dd HH:mm:ss'
  date = new Date(date) || new Date()
  if (typeof date === 'string') {
    formatStr = date
    date = new Date()
  }
  var str = formatStr
  str = str.replace(/yyyy|YYYY/, date.getFullYear())
  str = str.replace(
    /yy|YY/,
    date.getYear() % 100 > 9
      ? (date.getYear() % 100).toString()
      : '0' + date.getYear() % 100
  )
  str = str.replace(/MM/, twodigit(date.getMonth() + 1))
  str = str.replace(/M/g, date.getMonth() + 1)
  str = str.replace(/dd|DD/, twodigit(date.getDate()))
  str = str.replace(/d|D/g, date.getDate())
  str = str.replace(/hh|HH/, twodigit(date.getHours()))
  str = str.replace(/h|H/g, date.getHours())
  str = str.replace(/mm/, twodigit(date.getMinutes()))
  str = str.replace(/m/g, date.getMinutes())
  str = str.replace(/ss|SS/, twodigit(date.getSeconds()))
  str = str.replace(/s|S/g, date.getSeconds())
  return str
}

export const dateISO = (date) => {
  return new Date(date).toISOString().substring(0, 19) + 'Z'
}

/**
   * 手机号码验证
   */
export const isMobile = it => {
  return /^\d+$/.test(it)
}

/**
   * 短信验证码验证
   */
export const isSmsCode = it => {
  return true;///\d{6}/.test(it)
}

/**
 * 数字验证(2位小数)
 */
export const isNumber = it => {
  return /^[0-9]+\.{0,1}[0-9]{0,2}$/.test(it)
}

/**
*国际手机号码验证
*/
// export const  = it =>() {
//   // return /(?:\(?[0\+]?\d{1,3}\)?)[\s-]?(?:0|\d{1,4})[\s-]?(?:(?:13\d{9})|(?:\d{7,8}))/.test(it)
//   // return /^\d+$/.test(it)
//   return
// }
function trimStr(it) {
  return it.replace(/\s/g, '')
}
export const isPhoneAtAll = (it, phoneformat) => {
  return trimStr(phoneformat).length === trimStr(it).length
}
